import { useMapped } from "@omni/utils/context/mapped.context";
import { cn } from "@omni/utils/styles";
import { ReactNode, useState } from "react";

import { CategorySlideContextProvider } from "@/components/Navigation/Sidebar/components/assortiment/components/categorySlide/context/categorySlide.context";
import {
    useCategory,
    useSidebarContext
} from "@/components/Navigation/Sidebar/context/sidebar.context";
import { getTagZoneIdFor } from "@/utils/tagging/tag.utils";

type Props = {
    className?: string;
    children: ReactNode;
};

export const Base = ({ className, children }: Props) => {
    const [closing, setClosing] = useState(false);

    const { setActiveCatetoryIndexes } = useSidebarContext();

    const { category } = useCategory();
    const { index } = useMapped();

    const handleOnAnimationEnd = () => {
        closing && setActiveCatetoryIndexes((prev) => prev.slice(0, index));
    };

    if (!category) return null;

    return (
        <CategorySlideContextProvider
            category={category}
            closing={closing}
            setClosing={setClosing}
        >
            <div
                className={cn(
                    "tw:flex tw:flex-col tw:absolute tw:top-0 tw:left-0 tw:h-full tw:w-full tw:overflow-hidden tw:bg-background tw:shadow-[-8px_0_16px_-4px_rgba(0,0,0,0.2)] tw:transition-shadow",
                    {
                        "tw:animate-slide-in-right": !closing,
                        "tw:animate-slide-out-right": closing
                    },
                    className
                )}
                {...getTagZoneIdFor(`flyout-menu-mobile-category-${index + 1}`)}
                onAnimationEnd={handleOnAnimationEnd}
            >
                {children}
            </div>
        </CategorySlideContextProvider>
    );
};
